import React, { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Header from '@components/portal/details/header';
import Sections from '@components/portal/details/sections';
import TopBar from '@components/portal/details/top-bar';
import {
  createEmptyDataSet,
  fetchDashboardDetailsData
} from '@actions/dashboard-actions';
import { getInitialValues } from '@utils/dashboard-details-utils';
import './details.scss';
import UnstyledHeading from '@components/shared/unstyled-heading';

const Details = () => {
  const { dataType, edit: editParam, id } = useParams();
  const { details } = useSelector(state => state.config);
  const dispatch = useDispatch();

  const edit = useMemo(() => editParam === 'edit' || id === 'new', [editParam, id]);

  useEffect(() => {
    if (id === 'new') {
      const fields = details[dataType];
      const initialValues = getInitialValues(fields);
      dispatch(createEmptyDataSet(dataType, initialValues));
    } else {
      dispatch(fetchDashboardDetailsData(dataType, id));
    }
  }, [id, dataType, details, dispatch]);

  return (
    <div styleName="portal-details-container">
      <UnstyledHeading rank={2} ariaOnly>{dataType} details</UnstyledHeading>
      <TopBar edit={edit} />
      {/* tabIndex so this scrollable region stays reachable by keyboard even when its
          content has no focusable fields of its own (e.g. a read-only details view). */}
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <div styleName="portal-details-content" tabIndex={0}>
        {!edit && dataType !== 'batch' && <Header />}
        <Sections edit={edit} />
      </div>
    </div>
  );
};

export default memo(Details);
